import { Drawer } from "@mui/material";
import Title from "components/BPTitle";
import TitlesList from "components/BPTitlesList";
import Publication from "components/Publication";
import type { ITitle } from "containers/Titles/types";
import { PortalType } from "contexts/portal.context";
import { useIsMobile } from "hooks/useIsMobile";
import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import type { RootState } from "store/store";
import { useAppSelector } from "store/store";
import { EPortalType } from "store/types";

const TitlesBeneficiarPortal = () => {
    const portalType = useContext(PortalType);
    const titles = useSelector((state: RootState) => state.titles.beneficiarTitles);
    const { beneficiarCompagnies } = useSelector((state: RootState) => state.beneficiary);
    const onOpenTitleDrawer = useAppSelector((state) => state.settings.showTitleDrawer);
    const params = useParams();
    const navigate = useNavigate();
    const { isMobile } = useIsMobile();
    const [isPressTitle, setIsPressTitle] = useState(false);
    const [currentTitle, setCurrentTitle] = useState<number>(params.id ? +params.id : -1);

    useEffect(() => {
        if (titles && titles.length > 0 && !params.id) {
            setIsPressTitle(
                ["audiovisual", "press"].includes(
                    beneficiarCompagnies.find((item) => item.id === titles[0].companyId)?.publisherType ?? "",
                ),
            );
            setCurrentTitle(titles[0].id);
            navigate(`/titles/${titles[0].id}`);
        }
    }, [titles, beneficiarCompagnies]);

    const setTitle = useCallback(
        (title: ITitle) => {
            setIsPressTitle(
                ["audiovisual", "press"].includes(
                    beneficiarCompagnies.find((item) => item.id === title.companyId)?.publisherType ?? "",
                ),
            );
            setCurrentTitle(title.id);
            navigate(`/titles/${title.id}`);
        },
        [navigate, beneficiarCompagnies],
    );

    const selectedTitle = useMemo(() => {
        const currTitle = titles.find((item: ITitle) => item.id === currentTitle);
        setIsPressTitle(
            ["audiovisual", "press"].includes(
                beneficiarCompagnies.find((item) => item.id === currTitle?.companyId)?.publisherType ?? "",
            ),
        );
        return currTitle;
    }, [titles, currentTitle, beneficiarCompagnies]);
    return (
        <>
            <TitlesList titles={titles} currentTitle={currentTitle} setCurrentTitle={setTitle} />
            {isPressTitle && !isMobile && <Publication beneficiaryCompanies={beneficiarCompagnies} />}
            {!isPressTitle && !isMobile && <Title currentTitle={selectedTitle} titles={titles} />}
            {portalType === EPortalType.BENEFICIARY && isMobile && (
                <Drawer open={onOpenTitleDrawer} anchor="right" sx={titleDrawerStyle}>
                    {isPressTitle ? <Publication /> : <Title currentTitle={selectedTitle} titles={titles} />}
                </Drawer>
            )}
        </>
    );
};

const titleDrawerStyle = {
    ".MuiPaper-root": { width: "100vw " },
};

export default TitlesBeneficiarPortal;
